export default __webpack_public_path__ + "static/carregador-mobile-309f73db744783e002b2769e17619ea0.jpg";